"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function CaseStudyTwo() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const stats = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const agingStats = [{
    label: "Challenge",
    value: "",
    description: "A major government department faced rising absenteeism and declining morale following a period of significant structural change."
  }, {
    label: "Approach",
    value: "",
    description: "We implemented the Wellbeing Risk Radar to identify specific stressors, followed by targeted leadership training and peer-support networks."
  }, {
    label: "Result",
    value: "",
    description: "A measurable reduction in stress-related absence, resulting in £1.2 million in saved productivity costs within the first 12 months."
  }];
  return <section data-section-id="2690" id="case-study-two" className="bg-background text-foreground py-[120px] md:py-[180px] px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div ref={intro.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 transition-all duration-1000 ease-out ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-8">
            <p className="font-mono uppercase mb-8 md:mb-12" style={{
            fontSize: "11px",
            letterSpacing: "0.25em",
            color: "var(--secondary)"
          }}>
              Civil service
            </p>
            <h2 className="font-default leading-[1.05] text-[2.5rem] sm:text-[3rem] md:text-[3.5rem] lg:text-[4rem]" style={{
            fontWeight: 600,
            color: "var(--foreground)"
          }}>
              £1.2 million saved through strategic wellbeing intervention.
            </h2>
          </div>
          <div className="lg:col-span-4 flex items-end">
            <p className="font-default text-base md:text-lg leading-relaxed" style={{
            color: "var(--muted-foreground)"
          }}>
              A major government department faced rising absenteeism and declining morale following a period of significant structural change.
            </p>
          </div>
        </div>

        <div ref={stats.ref} className={`mt-20 md:mt-[80px] grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0 relative transition-all duration-1000 ease-out delay-150 ${stats.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {agingStats.map((stat, i) => <div key={stat.label} data-index={i} className="relative md:px-3">
              {i > 0 && <div className="hidden md:block absolute left-0 top-8 bottom-8 w-px" style={{
            borderLeft: "1px dotted var(--primary)",
            opacity: 0.4
          }} aria-hidden="true" />}
              <Card className="h-full p-10 md:p-12 rounded-lg shadow-md gap-0" style={{
            backgroundColor: "var(--card)",
            border: "1px solid var(--border)"
          }}>
                <p className="font-mono uppercase mb-8" style={{
              fontSize: "11px",
              letterSpacing: "0.25em",
              color: "var(--secondary)"
            }}>
                  {stat.label}
                </p>
                <div className="font-default leading-none mb-6 text-[4rem] md:text-[5rem] lg:text-[6rem]" style={{
              fontWeight: 700,
              color: "var(--foreground)"
            }}>
                  {stat.value}
                </div>
                <div className="mb-6 h-px w-[60px]" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
                <p className="font-default text-sm leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                  {stat.description}
                </p>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}